var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYellow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 24,
    viewBox: "0 0 42 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 42,
    height: 23,
    rx: 11.5,
    fill: "#FFCD33"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9004 12.0741L13.1187 11.6509L14.5099 8.95388C14.5734 8.82793 14.5993 8.69421 14.5894 8.56331C14.5795 8.43154 14.5331 8.29874 14.4477 8.17739C14.3618 8.05534 14.2382 7.94749 14.0827 7.8701C13.9269 7.79253 13.748 7.75002 13.5631 7.75L12.9004 12.0741ZM12.9004 12.0741L13.1906 12.4517M12.9004 12.0741L13.1906 12.4517M13.1906 12.4517L15.1551 15.0078C15.2208 15.1275 15.2519 15.2562 15.2499 15.3828C15.2477 15.5194 15.2066 15.658 15.1238 15.7855C15.0406 15.9137 14.9165 16.0283 14.7574 16.111C14.5979 16.1939 14.4127 16.2397 14.2209 16.2398H10.7858H10.5434M13.1906 12.4517L10.5434 16.2398M10.5434 16.2398L10.3469 16.3816M10.5434 16.2398L10.3469 16.3816M10.3469 16.3816L8.75 17.5339V8.61756C8.75 8.61753 8.75 8.6175 8.75 8.61747C8.75005 8.41166 8.83935 8.19807 9.02555 8.02875C9.21424 7.85715 9.48408 7.75005 9.77846 7.75M10.3469 16.3816L9.77846 7.75M9.77854 7.75H13.5631H9.77854ZM9.77854 7.75C9.77851 7.75 9.77849 7.75 9.77846 7.75M9.77854 7.75H9.77846",
    stroke: "black",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.702 16.5H22.55V6.7H20.814C20.38 7.54 19.75 7.932 18.644 7.932V9.64C19.596 9.64 20.184 9.486 20.702 8.982V16.5ZM24.1398 11.6C24.0978 14.624 26.0298 16.738 28.5638 16.696C31.0978 16.738 33.0298 14.624 32.9878 11.6C33.0298 8.576 31.0978 6.462 28.5638 6.504C26.0298 6.462 24.0978 8.576 24.1398 11.6ZM31.1398 11.6C31.1398 13.714 30.0758 14.988 28.5638 14.988C27.0518 14.988 25.9878 13.714 25.9878 11.6C25.9878 9.486 27.0518 8.212 28.5638 8.212C30.0758 8.212 31.1398 9.486 31.1398 11.6Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellow);
export default __webpack_public_path__ + "static/media/yellow.9500d46513f77a9b769660e5227ef61e.svg";
export { ForwardRef as ReactComponent };